import {cycleSignFeature} from './cycle-sign.reducer';

export default cycleSignFeature;
